const Chartkick = require("chartkick").default;
window.Chartkick = Chartkick;

const Chart = require("chart.js");
Chartkick.addAdapter(Chart);
